import withCountry from 'enhancers/withCountry';
import withScoresPageQuery, { WithScoresPageQueryProps } from 'enhancers/withScoresPageQuery';
import * as React from 'react';

type Props = WithScoresPageQueryProps;

export const ScoresPage: React.SFC<Props> = props => {
  if (
    !props.loading &&
    props.data &&
    props.data.fetch.Country.Scores &&
    props.data.fetch.Country.Scores.IFrame
  ) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: props.data.fetch.Country.Scores.IFrame
        }}
      />
    );
  }
  return null;
};

export default withCountry(withScoresPageQuery(ScoresPage));



// WEBPACK FOOTER //
// ./src/pages/ScoresPage/ScoresPage.tsx